import React from 'react'
import { AppFormItem as AppFormItemProps } from 'api/index'

export interface AppLabelProps {
	width?: number | string
	value?: string
}

export default class AppLabel extends React.Component<AppLabelProps> {
	state = {}

	render() {
		// if (this.props.render) {
		// 	return this.props.render()
		// }
		return <label style={{ textAlign: 'right' }}>{this.props.value || ''}</label>
	}
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppLabel.tsx